import React, {Component} from 'react';
import {
  Row,
  Col,
  Input,
  Form,
  FormGroup,
  Label,
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  Badge
} from 'reactstrap'

const sprintf = require('sprintf-js').sprintf;
const R = require('ramda')

class StudentList extends Component {

  constructor(props) {
    super(props);
    this.BADGE_FORMAT = '%s | %s | %s';
    this.state = {
      filterLetter: 'A',
      filterText: '',
    };
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onChangeLetter = this.onChangeLetter.bind(this);
  }

  filterStudentList(list, filterText, filterLetter) {
    if (filterText === '') {
      let f = R.clone(list);
      if (filterText.length < 2) {
        f = R.filter(u => R.head(u.lastName).toLowerCase() === filterLetter.toLowerCase(), f);
      }
      return R.sort((a,b) => (a.lastName+' '+a.firstName < b.lastName+' '+b.firstName) ? -1 : 1, f);
    } else {
      let f = R.filter(u => {
        return u.lastName.toLowerCase().indexOf(filterText.toLowerCase()) >= 0 ||
          u.firstName.toLowerCase().indexOf(filterText.toLowerCase()) >= 0 ||
          u.stuID.toLowerCase().indexOf(filterText.toLowerCase()) >= 0;
      }, list);
      if (filterText.length < 2) {
        f = R.filter(u => R.head(u.lastName).toLowerCase() === filterLetter.toLowerCase(), f);
      }
      return R.sort((a,b) => (a.lastName+' '+a.firstName < b.lastName+' '+b.firstName) ? -1 : 1, f);
    }
  }

  onChangeLetter(evt) {
    let filterLetter = evt.currentTarget.getAttribute('data-key');
    this.setState({filterLetter});
  }

  onFilterChange(evt) {
    let filterText = evt.currentTarget.value;
    this.setState({filterText});
  }

  render() {
    let _this = this;
    let letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let studentList = R.values(this.props.studentObjs);
    let filteredStudentList = this.filterStudentList(studentList, this.state.filterText, this.state.filterLetter);
    let list = (filteredStudentList.length === 0) ? <h4 className="text-center">There are no students to show</h4> :
      (
        <div className="">
          <ListGroup className="list-scroll">
            {
              filteredStudentList.map((stu, idx) => {
                let className = (stu.lopCount > 0 || (stu.acGPA !== '' && stu.acGPA < 2.0) || (stu.citGPA !== '' && stu.citGPA < 2.0) || stu.finance || stu.library) ? 'cursor-pointer on-lop' : 'cursor-pointer off-lop';
                return (
                  <ListGroupItem active={stu && stu.stuID === this.props.selectedStuID}
                                 key={stu.stuID}
                                 data-key={stu.stuID}
                                 onClick={_this.props.onStudentSelected}
                                 className={className}>
                    <Row>
                      <Col md={8}>
                        {stu.lastName+', '+stu.firstName}
                      </Col>
                      <Col md={4} className="text-right">
                        <Badge className="student-detail">{sprintf(this.BADGE_FORMAT, stu.stuID, stu.classOf, stu.grade)}</Badge>
                      </Col>
                    </Row>
                  </ListGroupItem>
                );
              })
            }
          </ListGroup>
        </div>
      );

    return (
      <Col md={5}>
        <Card>
          <CardHeader>
            <Row>
              {
                (this.state.filterText.length < 2) ?
                  <Col md={12} className={"text-center"}>
                    {
                      letters.split('').map(l => {
                        let className = (l === this.state.filterLetter) ? 'letter-filter btn-primary' : 'letter-filter btn-secondary';
                        return (<span key={l+'key'} data-key={l} className={className} onClick={this.onChangeLetter}>{l}</span>);
                      })
                    }
                  </Col> :
                  <Col md={12}>{<span className="letter-filter">  </span>}</Col>
              }
            </Row>
            <Form className="list-grid-parent">
              <FormGroup row>
                <Label for="filter" md={3}>Filter:</Label>
                <Col sm={9}>
                  <Input type="text" name="filter" id="filter"
                         onChange={this.onFilterChange}
                         value={this.state.filterText}/>
                </Col>
              </FormGroup>
            </Form>
            <Row>
              <Col md={8}>
                Student name
              </Col>
              <Col md={4}>
                <Badge className="student-detail">{sprintf(this.BADGE_FORMAT, 'ID', 'C/O', 'Gr')}</Badge>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            {list}
          </CardBody>
        </Card>
      </Col>
    );
  }

}

export default StudentList





// WEBPACK FOOTER //
// ./src/views/StudentList.js